import stateApi from '@/api/stateApi';
import { useHandleError } from '@/lib/errors';
import { Loader } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useEffect } from 'react';

export default function ConnectionStatus() {
  const { enabled, connected, error } = stateApi.connection.useStore();

  useHandleError(error, {
    autoClose: false,
    withCloseButton: false,
  });

  useEffect(() => {
    if (!enabled || connected) return;

    const id = notifications.show({
      message: 'Connecting to server...',
      icon: <Loader size="sm" />,
      color: 'transparent',
      autoClose: false,
      withCloseButton: false,
    });

    return () => {
      notifications.hide(id);
    };
  }, [enabled, connected]);

  return null;
}
